var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.loaded)?[_c('v-app',[(_vm.current_user)?_c('TopBar'):_vm._e(),_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('spacing',[_c('v-row',[_c('v-col',[_c('router-view')],1)],1)],1)],1)],1)],1)]:_c('loading'),_c('IndeDialog'),_c('DeleteDialog')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }